import { render, staticRenderFns } from "./OsReportForm.vue?vue&type=template&id=766f9a40&scoped=true"
import script from "./OsReportForm.vue?vue&type=script&lang=ts"
export * from "./OsReportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f9a40",
  null
  
)

export default component.exports